"use strict";

function midPointBtw(p1, p2) {
  return {
    x: p1.x + (p2.x - p1.x) / 2,
    y: p1.y + (p2.y - p1.y) / 2
  };
}

function freehandCanvas() {
  return {
    restrict: "E",
    replace:  true,
    template: "<canvas></canvas>",
    require: "ngModel",
    link: function(scope, elem, attrs, ngModel) {
      var el        = elem[0];
      var ctx       = el.getContext('2d');
      var isDrawing = false;
      var points    = [];
      var lines     = [];

      function start(e) {
        isDrawing = true;

        addPoint(e.clientX, e.clientY);
      }

      function mouseMove(e) {
        if( ! isDrawing) {
          return;
        }

        move(e.clientX, e.clientY);
      }
      
      function touchMove(e) {
        e.preventDefault();

        move(e.targetTouches[0].clientX, e.targetTouches[0].clientY);
      }
      
      function addPoint(viewportX, viewportY) {
        var rect = el.getBoundingClientRect();
        
        points.push({
          x: viewportX - rect.left,
          y: viewportY - rect.top
        });
      }
      
      function move(x, y) {
        addPoint(x, y);

        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

        for(var i = 0; i < lines.length; i++) {
          drawLine(lines[i]);
        }

        drawLine(points);
      }
      
      function drawLine(line) {
        if(line.length < 2) {
          return;
        }

        var p1 = line[0];
        var p2 = line[1];

        ctx.beginPath();
        ctx.moveTo(p1.x, p1.y);

        for(var i = 1, len = line.length; i < len; i++) {
          // we pick the point between pi+1 & pi+2 as the
          // end point and p1 as our control point
          var midPoint = midPointBtw(p1, p2);

          ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);

          p1 = line[i];
          p2 = line[i + 1];
        }

        // Draw last line as a straight line while
        // we wait for the next point to be able to calculate
        // the bezier control point
        ctx.lineTo(p1.x, p1.y);
        ctx.stroke();
      }

      function end() {
        if(points.length < 2) {
          return;
        }

        lines.push(points);

        isDrawing       = false;
        points          = [];

        scope.$apply(function() {
          ngModel.$setViewValue(lines.length ? el.toDataURL("image/png") : "");
        });
      }

      ctx.lineWidth   = parseInt(attrs.lineWidth, 10) || 3;
      ctx.lineJoin    = ctx.lineCap = 'round';
      ctx.lineStyle   = "#000";
      ctx.strokeStyle = "#000";

      el.addEventListener("mousedown",  start,     false);
      el.addEventListener("mousemove",  mouseMove, false);
      el.addEventListener("mouseup",    end,       false);

      el.addEventListener("touchstart", start,     false);
      el.addEventListener("touchmove",  touchMove, true);
      el.addEventListener("touchend",   end,       false);

      document.body.addEventListener("mouseup",     end, false);
      document.body.addEventListener("touchcancel", end, false);
      
      ngModel.$render = function() {
        if( ! ngModel.$viewValue) {
          lines = [];

          ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        }
      };
    }
  };
}

angular.module("dokiv")
  .directive("freehandCanvas", freehandCanvas);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/FreehandCanvas.js
// module id = 244
// module chunks = 0